import React, { createContext, useState, useContext } from 'react';
import { getItem, setItem } from '@analytics/storage-utils';

const ContactContext = createContext(null);
const CONTACT_KEY = "contact";
const getContactDetails = () => {
    let contact = null;
    try {
        contact = getItem(CONTACT_KEY);
    }
    catch (_a) {
        console.error("Peek Error: Storage error. Unable to READ contact details!!!");
    }
    return contact;
};
function ContactProvider({ children }) {
    const [contactDetails, setContactDetails] = useState(getContactDetails());
    const saveContactDetails = (details) => {
        try {
            const mergedDetails = Object.assign(Object.assign({}, contactDetails), details);
            setContactDetails(mergedDetails);
            setItem(CONTACT_KEY, mergedDetails);
        }
        catch (_a) {
            console.error("Peek Error: Storage error. Unable to SAVE contact details!!!");
        }
    };
    return (React.createElement(ContactContext.Provider, { value: {
            contactDetails,
            setContactDetails: saveContactDetails,
        } }, children));
}
function useContact() {
    return useContext(ContactContext);
}

export { CONTACT_KEY, ContactProvider, useContact };
